import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { themes } from '../config/themes';

export default function ThemePicker({ selectedTheme, onThemeChange }) {
  const pickerRef = useRef(null);

  const handleThemeChange = (themeId) => {
    onThemeChange(themeId);
    if (pickerRef.current) pickerRef.current.removeAttribute('open');
  };

  return (
    <details className="top-theme-picker" ref={pickerRef}>
      <summary title="Alterar cor do sistema" aria-label="Alterar cor do sistema">
        <i className="pi pi-palette" />
        <span>Tema</span>
      </summary>
      <div className="top-theme-popover">
        <div className="top-theme-heading">
          <span className="top-theme-icon"><i className="pi pi-palette" /></span>
          <div><strong>Cor do sistema</strong><small>A preferência será salva para seu usuário.</small></div>
        </div>
        <div className="top-theme-options" role="radiogroup" aria-label="Escolha a cor do sistema">
          {themes.map(theme => (
            <button
              key={theme.id}
              type="button"
              role="radio"
              aria-checked={selectedTheme === theme.id}
              className={selectedTheme === theme.id ? 'is-selected' : ''}
              onClick={() => handleThemeChange(theme.id)}
            >
              <span className="top-theme-swatch" style={{ backgroundColor: theme.color }}><i className="pi pi-check" /></span>
              <span><strong>{theme.name}</strong><small>{theme.description}</small></span>
            </button>
          ))}
        </div>
      </div>
    </details>
  );
}

ThemePicker.propTypes = {
  selectedTheme: PropTypes.string.isRequired,
  onThemeChange: PropTypes.func.isRequired,
};
